// @flow strict

import type { Props, ComputedStyles } from './ReadMoreBase';
import ReadMoreBase from './ReadMoreBase';
// eslint-disable-next-line css-modules/no-unused-class
import styles from './ReadMore.css';

/**
 * Show a limited number of content text lines with a 'Read more' CTA and reveal the remaining content when the content or CTA is clicked.
 * The CTA is rendered below the last line of text, which fades to white. Props allow for the CTA and click behavior to be customized.
 */
export default class ReadMoreFadeOut extends ReadMoreBase {
  constructor(props: Props) {
    super(props);
    this.variantCssClass = styles.variantFadeOut;
  }

  computeStateFromStyles = (computedStyles: ComputedStyles) => {
    // If the content isn't long enough to overflow the constrained-height div, then update the state so that we don't render the 'Read more' link.
    if (computedStyles.scrollHeight <= computedStyles.lineHeight * this.props.numLinesToShow) {
      return this.contentRevealedState;
    }

    // Actual div height is based on numLinesToShow+1 to make room for the 'Read more' link.
    const divHeight = computedStyles.lineHeight * (this.props.numLinesToShow + 1);

    if (this.state.divHeight !== divHeight) {
      // Adjust the div height

      this.ctaStyles = {
        fontSize: `${computedStyles.fontSize}px`,
        lineHeight: `${computedStyles.lineHeight}px`,
        backgroundImage: `linear-gradient(rgba(255, 255, 255, 0) 0px, white ${
          computedStyles.lineHeight
        }px)`,

        paddingTop: `${computedStyles.lineHeight}px`,
      };
      this.collapsedCtaStyles = {
        fontSize: `${computedStyles.fontSize}px`,
        lineHeight: `${computedStyles.lineHeight}px`,
        backgroundImage: `linear-gradient(rgba(255, 255, 255, 0) 0px, white ${
          computedStyles.lineHeight
        }px)`,
      };

      return { collapsed: true, divHeight };
    }
    // No change
    return this.state;
  };
}
